import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TriviaService } from '../trivia.service';
import { ModalService } from '@features/modals/services/modal.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import { ToastrService } from 'ngx-toastr';
import { ITriviaRainForm } from '../interfaces/trivia.interface';

@Component({
  selector: 'app-trivia-rain-modal',
  imports: [FormFieldComponent, ReactiveFormsModule],
  templateUrl: './trivia-rain-modal.component.html',
  styleUrl: './trivia-rain-modal.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class TriviaRainModalComponent {
  private readonly triviaService = inject(TriviaService);
  private readonly modalService = inject(ModalService);
  private readonly toastrService = inject(ToastrService);

  question = new FormControl<string>('', [Validators.required]);
  correctAnswer = new FormControl<string>('', [Validators.required]);
  answer2 = new FormControl<string>('', [Validators.required]);
  answer3 = new FormControl<string>('', [Validators.required]);
  answer4 = new FormControl<string>('', [Validators.required]);
  reward = new FormControl<number>(1, [Validators.required, Validators.min(1)]);

  triviaRainForm = new FormGroup({
    question: this.question,
    correctAnswer: this.correctAnswer,
    answer2: this.answer2,
    answer3: this.answer3,
    answer4: this.answer4,
    reward: this.reward,
  });

  async onSubmit() {
    this.triviaRainForm.markAllAsTouched();

    if (!this.triviaRainForm.valid) {
      this.toastrService.error(
        'Form is not valid. Please check the inputs. All fields are required, min reward is 1'
      );
      return;
    }

    const formValues = this.triviaRainForm.value;

    const triviaRain: ITriviaRainForm = {
      question: formValues.question!,
      answer: formValues.correctAnswer!,
      options: [formValues.answer2!, formValues.answer3!, formValues.answer4!],
      reward: Number(formValues.reward!),
    };

    try {
      await this.triviaService.createRainTrivia(triviaRain);
      this.toastrService.success('Trivia has been created successfully');
      this.modalService.close();
    } catch (error) {
      console.log('🚀 ~ TriviaRainModalComponent ~ onSubmit ~ error:', error);
    }
  }
}
